import $ from 'jquery';
import Grapnel from 'grapnel';
import StartMasonary from './scripts/components/start';
import Articles from './scripts/components/articles';
import Filter from './scripts/components/filter';
import SelectedFilters from './scripts/components/selectedFilters';

import Banners from './scripts/components/banners';

import MyPages from './scripts/components/mypages';
import CountryNames from './scripts/helpers/countries';

let React = require('react');
let ReactDOM = require('react-dom');

require('./sass/index.scss');

$.fn.hasParent = function(objs) {
  // ensure that objs is a jQuery array
  objs = $(objs); var found = false;
  $(this[0]).parents().andSelf().each(function() {
    if ($.inArray(this, objs) != -1) {
      found = true;
      return false; // stops the each...
    }
  });
  return found;
}

$(window).load(() => {
  const $scrollToOnLoad = $('.scroll-to-on-load');
  if ($scrollToOnLoad.length) {
    const scrollTop = $scrollToOnLoad.first().offset().top - ($('.navbar').length ? $('.navbar').height() : 0) - 40;
    if (performance) {
      if (performance.navigation.type === 0) {
        $('html, body').scrollTop(scrollTop);
      }
    } else {
      $('html, body').scrollTop(scrollTop);
    }
  }
});

$(document).on('ready', () => {

  const $openPortableNavBtn = $('.js-open-portable-nav-btn');
  const $openPortableSearchBtn = $('.js-open-portable-search-btn');
  const $offCanvasView = $('.off-canvas-view');
  const $appCanvas = $('.js-app-canvas');
  const $body = $('body');

  /**
   * Off canvas views
   */
  function hidePortableNav() {
    jsdebug('hidePortableNav');
    $body.removeClass('is-off-canvas-view--left-open is-off-canvas-view--right-open');
  }

  $openPortableNavBtn.on('click', (e) => {
    jsdebug('openPortableNavBtn');
    $body.toggleClass('is-off-canvas-view--left-open');

    e.preventDefault();
    e.stopPropagation();
  });

  $openPortableSearchBtn.on('click', (e) => {
    jsdebug('openPortableSearchBtn');

    $body.toggleClass('is-off-canvas-view--right-open');

    e.preventDefault();
    e.stopPropagation();
  });

  $body.on('click', (e) => {
    jsdebug('body on click');

    if($offCanvasView.is(e.target) || $(e.target).hasParent($offCanvasView))
      return;

    hidePortableNav();
  });

  $(window).on('resize', () => {
    jsdebug('resize hide');

    // hidePortableNav();
  });

  /**
   * List filters
   */
  const $listFiltersContainer = $('.list-filters');
  const $toggleListFiltersBtn = $('.js-list-filters__toggle-btn');

  $toggleListFiltersBtn.click(function(){
    jsdebug('toggleListFiltersBtn');
    $listFiltersContainer.toggleClass('is-filters-open');
  });

  // tabababbababab
  const $tabs = $('.tabs');
  const $tab = $('a', $tabs);

  $tab.on('click', function(e) {
    const $this = $(this);
    const name = $this.data('tab');

    $tab.removeClass('is-active');
    $('*[data-tab-content]').removeClass('is-active');

    $this.addClass('is-active');
    $(`*[data-tab-content=${name}]`).addClass('is-active');

    e.preventDefault();
  });

  /**
   * Router
   */
  const router = new Grapnel({ pushState: true });

  function getQuery (req, event, next) {
    let query = {};

    if (window && window.location && window.location.search) {
      let search = window.location.search.substring(1);
      let vars = search.split('&');

      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');

        let key = decodeURIComponent(pair[0]);
        let value = decodeURIComponent(pair[1]);

        query[key] = value;
      }
    }

    for (let key in req.params) {
      query[key] = req.params[key];
    }

    req.query = query;

    next();
  }

  function addNavMenu (req, event, next) {

    // Ill leave this here if we want this functionality in the future
    /*
    let category = null;

    switch (req.match[0]) {
      case '/recept':
        category = 'recept';
        break;
      case '/artiklar':
        category = 'artiklar';
        break;
    }

    let query = req.query;

    ReactDOM.render(
      <Filter category={category} filter={query}/>,
      document.getElementById('navbar-filter')
    );
    */

    next();
  }

  router.get('', (req) => {
    var element = document.getElementById('start-holder');

    if (element) {
      ReactDOM.render(
        <StartMasonary category='start' />,
        document.getElementById('start-holder')
      );
    }
  });

  router.get('/artiklar', (req) => {
    ReactDOM.render(
      <Articles />,
      document.getElementById('article-list')
    );
    ReactDOM.render(
      <Banners />,
      document.getElementById('article-right')
    );
  });
  router.get('/artiklar/:tag', (req) => {
    ReactDOM.render(
      <Articles tag={req.params.tag}/>,
      document.getElementById('article-list')
    );
    ReactDOM.render(
      <Banners />,
      document.getElementById('article-right')
    );
  });
  router.get('/artikel/:author', (req) => {
    ReactDOM.render(
      <Articles author={req.params.author}/>,
      document.getElementById('article-list')
    );
    ReactDOM.render(
      <Banners />,
      document.getElementById('article-right')
    );
  });
  router.get('/recept', getQuery, addNavMenu, (req, event, next) => {
    let query = req.query;

    ReactDOM.render(
      <Filter category='recept' filter={query} mainFilter />,
      document.getElementById('list-filter')
    );

    ReactDOM.render(
      <Filter category='recept' filter={query} />,
      document.getElementById('navbar-filter')
    );

    ReactDOM.render(
      <SelectedFilters category='recept' filter={query} />,
      document.getElementById('selected-filter')
    );

    ReactDOM.render(
      <StartMasonary category='recept' filter={query} />,
      document.getElementById('start-holder')
    );
  });

  router.get('/sok', getQuery, (req) => {
    let query = req.query;

    ReactDOM.render(
      <StartMasonary category='sok' filter={query} />,
      document.getElementById('start-holder')
    );
  });

  router.get('/mina-sidor/sparade-artiklar-och-recept', getQuery, (req) => {
    ReactDOM.render(
      <MyPages />,
      document.getElementById('mypages-holder')
    );
  });

  function runProfile(req, event, next){
    let query = req.query;

    ReactDOM.render(
      <Filter category='alla' filter={query}/>,
      document.getElementById('list-filter')
    );

    ReactDOM.render(
      <Filter category='alla' filter={query}/>,
      document.getElementById('navbar-filter')
    );

    ReactDOM.render(
      <StartMasonary category='alla' filter={query} />,
      document.getElementById('start-holder')
    );
  }

  router.get('/profil', getQuery, addNavMenu, runProfile);
  router.get('/profil/:skribent', getQuery, addNavMenu, runProfile);

  router.get('*', addNavMenu, (req, event, next) => {
    const addr = req.match[0];

    switch (true) {
      case (addr.indexOf('/recept/') === 0):
      case (addr.indexOf('/recension/') === 0):
        let query = {};
        ReactDOM.render(
          <StartMasonary category='relaterade' filter={query} />,
          document.getElementById('start-holder')
        );

        break;
    }
  });

  if($('#product-recipe').length > 0) {
    $.post( 'https://tips.vinochmatguiden.se/api/get-product-data-by-recipe?url='+ window.location.href, function( data ) {
      $('#product-recipe').html(`
            <h3 class="title-small u-margin-t-m">Vintips</h3>
                <a href="${data.url}"><div class="product-container">
    <img alt="product-image" src="${data.image}" />
    <div class="flag-container">
        <span class="flag-icon" style="background-image: url('/public/img/flags/4x3/${CountryNames[data.country]}.svg')"></span><br>
    </div>
    <div class="product-name">${data.productNameBold || ''} ${data.productNameThin || ''}</div>
    <div class="product-info">
        <div class="product-details">
            ${data.volume ? `${data.volume} ml` : ''}${data.alcoholPercentage && data.volume ? ', ' :''} ${data.alcoholPercentage ? `${data.alcoholPercentage}%` : ''}
        </div>
        <div class="product-price">
            ${data.priceInclVat} kr
        </div>
    </div>
</div></a>
            `)
    });
  }
});



// WEBPACK FOOTER //
// ./src/index.js